<template>
  <div>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row border-bottom border-secondary mb-1">
      <div class="col-12">
        <b-form @submit.prevent="consultar()">
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Nome/Razão Prestador"
                  label-for="nip_razao_social_prestador">
                <input
                    id="nip_razao_social_prestador"
                    v-model="filtro.nip_razao_social_prestador"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="CPF/CNPJ do Prestador">
                <the-mask class="form-control" v-model="filtro.nip_cpf_cnpj_prestador"
                          :mask="['###.###.###-##', '##.###.###/####-##']"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Nome/Razão Tomador"
                  label-for="nip_razao_social_tomador">
                <input
                    id="nip_razao_social_tomador"
                    v-model="filtro.nip_razao_social_tomador"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="CPF/CNPJ do Tomador">
                <the-mask class="form-control" v-model="filtro.nip_cpf_cnpj_tomador"
                          :mask="['###.###.###-##', '##.###.###/####-##']"/>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Número da Nota"
                  label-for="nip_numero">
                <input
                    id="nip_numero"
                    v-model="filtro.nip_numero"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Tributação" label-for="nip_exigibilidade_iss">
                <select id="nip_exigibilidade_iss"
                        v-model="filtro.nip_exigibilidade_iss"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="1">Exigível</option>
                  <option value="2">Não Incidência</option>
                  <option value="3">Isenção</option>
                  <option value="4">Exportação</option>
                  <option value="5">Imunidade</option>
                  <option value="6">Exigibilidade Suspensa por Decisão Judicial</option>
                  <option value="7">Exigibilidade Suspensa por Processo Administrativo</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Exigibilidade" label-for="nip_municipio_incidencia">
                <select id="nip_municipio_incidencia"
                        v-model="filtro.nip_municipio_incidencia"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option v-bind:value="'='+entidade.mun_codigo">No Município</option>
                  <option v-bind:value="'<>'+entidade.mun_codigo">Fora do Município</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="ISS Retido" label-for="nip_iss_retido">
                <select id="nip_iss_retido"
                        v-model="filtro.nip_iss_retido"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Emissão Incial"
                  label-for="nip_emissao_inicial">
                <input
                    id="nip_emissao_inicial"
                    v-model="filtro.nip_emissao_inicial"
                    type="date"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Emissão Final"
                  label-for="nip_emissao_final">
                <input
                    id="nip_emissao_final"
                    v-model="filtro.nip_emissao_final"
                    type="date"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Inicial"
                  label-for="nip_competencia_inicial">
                <input
                    id="nip_competencia_inicial"
                    v-model="filtro.nip_competencia_inicial"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Final"
                  label-for="nip_competencia_final">
                <input
                    id="nip_competencia_final"
                    v-model="filtro.nip_competencia_final"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Simples Nacional" label-for="nip_optante_simples_nacional">
                <select id="nip_optante_simples_nacional"
                        v-model="filtro.nip_optante_simples_nacional"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="S">Optante</option>
                  <option value="N">Não Optante</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Ordenação" label-for="ordenacao">
                <select id="ordenacao"
                        @change="consultar()"
                        v-model="filtro.ordenacao"
                        class="custom-select" type="text">
                  <option value="sp.nip_emissao desc">Data de Emissão ↓</option>
                  <option value="sp.nip_emissao">Data de Emissão ↑</option>
                  <option value="sp.nip_competencia desc">Competência ↓</option>
                  <option value="sp.nip_competencia">Competência ↑</option>
                  <option value="sp.nip_valor desc">Valor da Nota ↓</option>
                  <option value="sp.nip_valor">Valor da Nota ↑</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Notas por Página" label-for="nota_pagina">
                <select id="nota_pagina"
                        @change="consultar()"
                        v-model="filtro.nota_pagina"
                        class="custom-select" type="text">
                  <option value="10">10/Pág.</option>
                  <option value="30">30/Pág.</option>
                  <option value="50">50/Pág.</option>
                  <option value="80">80/Pág.</option>
                  <option value="100">100/Pág.</option>
                  <option value="200">200/Pág.</option>
                  <option value="500">500/Pág.</option>
                  <option value="800">800/Pág.</option>
                  <option value="1000">1000/Pág.</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="'" class="text-white">
                <button type="submit"
                        v-bind:disabled="httpSync"
                        class="btn btn-label btn-primary mr-3"><i
                    class="bx bx-search label-icon"></i>
                  Consultar
                </button>
                <button v-if="httpSync" type="button" disabled
                        class="btn btn-label btn-success"><i
                    class="bx bx-loader bx-spin label-icon"></i>
                  Sincronizando...
                </button>
                <button v-else type="button" title="Sincronizar notas com o ADN"
                        @click="sincronizarNotas()"
                        class="btn btn-label btn-success"><i
                    class="bx bx-sync label-icon"></i>
                  Sincronizar
                </button>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <TableNotasImportadasAdmin :resumo="resumo" :list_notas="notas"/>
        <div v-show="notas && notas.length > 0" class="row">
          <div class="col-lg-12">
            <paginate
                v-model="filtro.pagina"
                :page-count="total_paginas"
                :page-range="3"
                :margin-pages="3"
                :click-handler="proximaPagina"
                :prev-text="'Página anterior'"
                :next-text="'Próxima página'"
                :prev-link-class="'page-link'"
                :next-link-class="'page-link'"
                :page-link-class="'page-link'"
                :container-class="'pagination pagination-rounded justify-content-center mt-4'"
                :page-class="'page-item'">
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {TheMask} from 'vue-the-mask'
import Paginate from 'vuejs-paginate'
import Aguarde from "@/components/widgets/aguarde.vue";
import moment from "moment/moment";
import {listNotasImportadasAdmin, sincronizaNotasNacionalAdmin} from "@/api/admin/gestao/notas_importadas";
import {notifyAviso, notifyErro, notifySucesso} from "@/helps/notificacao";
import TableNotasImportadasAdmin from "@/router/views/admin/nfse/components/table-nfse-importadas.vue";

export default {
  components: {
    Paginate,
    TableNotasImportadasAdmin,
    Aguarde,
    TheMask
  },
  data() {
    return {
      notas: [],
      resumo: {},
      total_paginas: 0,
      httpSend: false,
      httpSync: false,
      filtro: {
        nip_numero: "",
        nip_emissao_inicial: moment().subtract(90, "days").format('YYYY-MM-DD'),
        nip_emissao_final: moment().format('YYYY-MM-DD'),
        nip_competencia_inicial: "",
        nip_competencia_final: "",
        nip_exigibilidade_iss: "",
        nip_municipio_incidencia: "",
        nip_iss_retido: "",
        nip_optante_simples_nacional: "",
        nip_cpf_cnpj_prestador: "",
        nip_razao_social_prestador: "",
        nip_cpf_cnpj_tomador: "",
        nip_razao_social_tomador: "",
        ordenacao: "sp.nip_emissao desc",
        pagina: 1,
        nota_pagina: "10"
      },
    };
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
  },
  created() {
    this.listNotas();
  },
  methods: {
    consultar() {
      this.filtro.pagina = 1;
      this.listNotas();
    },
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.listNotas()
    },
    sincronizarNotas() {
      if (!this.entidade || !this.entidade.mun_codigo) {
        notifyErro('Notas Fiscais Importadas', 'Município da entidade não localizado.');
        return;
      }
      this.httpSync = true;
      sincronizaNotasNacionalAdmin(this.entidade.mun_codigo).then(result => {
        if (result && result.status) {
          notifySucesso('Notas Fiscais Importadas', result.mensagem || 'Notas sincronizadas com sucesso');
          this.consultar();
        } else {
          notifyAviso('Notas Fiscais Importadas', (result && result.mensagem) || 'Não foi possível sincronizar as notas');
        }
      }).catch(error => {
        const mensagem = error.response && error.response.data && error.response.data.mensagem;
        notifyErro('Notas Fiscais Importadas', mensagem || 'Falha de comunicação com o servidor ao sincronizar as notas.');
      }).finally(() => {
        this.httpSync = false;
      })
    },
    listNotas() {
      this.httpSend = true;
      listNotasImportadasAdmin(this.filtro).then(result => {
        this.resumo = result.dados.resumo;
        this.total_paginas = result.dados.paginas;
        this.notas = result.dados.notas;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>
